module.exports = __webpack_public_path__ + "static/media/apsfl.b62b675d.png";